import { IConfig } from '@cian/config/shared';
import { ILogger } from '@cian/logger/shared';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorBound } from '../../components/ErrorBound';
import { TReduxStore } from '../../types/redux';
import { ICustomContextParams } from '../../types/ICustomContextParams';
import { App } from '../../components/app/app';

export interface IApplicationContext {
  config: IConfig;
  logger: ILogger;
}

export interface IApplicationProps extends IApplicationContext {
  reduxStore: TReduxStore;
  customContext: ICustomContextParams;
}

export type TApplicationСontextTypes = {
  [K in keyof IApplicationContext]: PropTypes.Requireable<IApplicationContext[K]>;
};

export class Application extends React.Component<IApplicationProps> {
  // TODO: переделать на React Context API
  public static childContextTypes: TApplicationСontextTypes = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    config: PropTypes.object as any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logger: PropTypes.object as any,
  };

  public constructor(props: IApplicationProps) {
    super(props);
  }

  // TODO: переделать на React Context API
  public getChildContext(): IApplicationContext {
    return {
      config: this.props.config,
      logger: this.props.logger,
    };
  }

  public render() {
    const { reduxStore, logger } = this.props;

    return (
      <Provider store={reduxStore}>
        <ErrorBound logger={logger}>
          <App />
        </ErrorBound>
      </Provider>
    );
  }
}
